
import { useMemo } from "react";
import { BillingSubscription } from "../../../types/subscription";
import { useUserStore } from "../store/userStore";

export function useUserSubscriptions(
  subscriptions: BillingSubscription[],
  user: { email?: string; phone?: string }
) {
  const { users } = useUserStore();

  return useMemo(() => {
    if (!user.email && !user.phone) return [];

    // Prefer email, fallback to phone
    const matchedUsers = users.filter(u => {
      if (user.email) {
        return u.email?.toLowerCase() === user.email.toLowerCase();
      }
      if (user.phone) {
        return u.phone === user.phone;
      }
      return false;
    });

    const userIds = matchedUsers.map(u => u.id);

    console.log("UserIds", userIds);

    const matchedSubscriptions = subscriptions.filter(sub =>
      userIds.includes(sub.userid)
    );

    console.log("Matched Subscriptions", matchedSubscriptions);

    return matchedSubscriptions.map(sub => {
      const matchedUser = matchedUsers.find(u => u.id === sub.userid);
      return {
        service_name: sub.service_name,
        package_name: sub.package_name,
        amount: sub.price,
        status: sub.status,
        startDate: sub.created_at,
        endDate: sub.renewed_at,
        location: matchedUser?.country ?? null,
        registeredAt: matchedUser?.createdAt ?? null,
      };
    });
  }, [users, subscriptions, user]);
}
